import React, { useState } from 'react';
import { PEOPLE_ASSETS } from './assets/assets.js';
import './index.css';
import Footer from '../../About/Footer';
const PeopleImpactSection = () => {
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <div className="people-multipliers-wrapper">
      
      <section className="people-factor-section">
        <div className="people-factor-container">
          <div className="people-factor-left">
            <h2 className="people-factor-heading">
              “We Believe in the <span className="mk-blue-text">People Factor</span> as the Most Important Edge to Growth”
            </h2>
            <div className="people-factor-content">
              <div className="vertical-line"></div>
              <div className="people-factor-text">
                <p>At Markoknow, growth is not driven by scale, speed, or systems alone — it is driven by people.</p>
                <p>Our research into employability, workforce readiness, and long-term career outcomes consistently points to one truth: organizations grow sustainably only when people grow meaningfully.</p>
              </div>
            </div>
          </div>
          <div className="people-factor-right">
            <img 
              src={PEOPLE_ASSETS.hero} 
              alt="People Factor" 
              className="people-factor-image"
              loading="eager"        
              fetchpriority="high"  
            />
          </div>
        </div>
      </section>

      <section className="mk-multipliers-section">
        <div className="mk-multipliers-container">
          <div className="mk-multipliers-left">
            {[0, 1, 2].map((i) => (
              <div className="mk-multiplier-point" key={i}>
                <div className="mk-point-icon-wrapper">
                  <img 
                    src={PEOPLE_ASSETS.multi} 
                    alt="icon" 
                    className="mk-multiplier-icon" 
                    loading="lazy" 
                  />
                </div>
                <p>
                  {i === 0 && "At Markoknow, we don't see people as roles, titles, or headcount. We see them as multipliers of impact."}
                  {i === 1 && "They contribute more thoughtfully, take ownership, and build solutions that scale beyond themselves."}
                  {i === 2 && "Our internal culture reflects the same employability principles we study externally."}
                </p>
              </div>
            ))}
          </div>
          <div className="mk-multipliers-center">
            <img 
              src={PEOPLE_ASSETS.multi} 
              alt="Multipliers Graphic" 
              className="mk-multiplier-main-img" 
              loading="lazy" 
            />
          </div>
          <div className="mk-multipliers-right">
            <h2 className="mk-multipliers-heading">
              People Are Not Resources — They Are <span className="mk-blue-text">Multipliers</span>
            </h2>
          </div>
        </div>
      </section>

      <section className="mk-accordion-section">
        <div className="mk-container-full">
          <h2 className="mk-accordion-title">Why the People Factor Drives Growth?</h2>
          
          <div className="mk-accordion-container desktop-only">
            {PEOPLE_ASSETS.accordion.map((item, index) => (
              <div 
                key={item.id}
                className={`mk-accordion-item ${hoveredIdx === index ? 'expanded' : ''}`}
                onMouseEnter={() => setHoveredIdx(index)}
                onMouseLeave={() => setHoveredIdx(null)}
                style={{ backgroundImage: `url(${hoveredIdx === index ? item.hover : item.normal})` }}
              >
                <img src={item.normal} alt="" style={{ display: 'none' }} loading="lazy" />
                <img src={item.hover} alt="" style={{ display: 'none' }} loading="lazy" />
              </div>
            ))}
          </div>

          <div className="mk-mobile-stack mobile-only">
            {PEOPLE_ASSETS.accordion.map((item) => (
              <div key={item.id} className="mk-mobile-card">
                <img 
                  src={item.hover} 
                  alt={item.alt} 
                  className="mk-mobile-img" 
                  loading="lazy" 
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PeopleImpactSection;